import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.20.0_@emnapi+core@1.5.0_@emnapi+runtime@1.5.0_@netlify+blobs@9.1.2_@types+node@2_c0aef0fd05637f3cd51588055b816b76/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}